/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { closeWebView } from '@/api/native/utils';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { confirmDialog } from '@/components/dialog';
import { Vue } from 'vue-property-decorator';
import store from '@/store';
import { isHelloWechatMini } from '@/api/native/wechat';
import platform from '../platform';
import { jumpToNewVersion, jumpToWalletTab } from '../jumpTo';
import { ubtPageButtonNew } from '../ubt';

/** 有无账号已注销的弹窗标识，关闭时前置条件 */
let hasLogoutConfirmDialog = false;

/** 账号已注销后，展示确认框，支持重新注册 */
export const logoutUserDialog = (that: Vue) => {
  hasLogoutConfirmDialog = true;

  confirmDialog.open({
    title: '账户安全',
    content: '您的账户已注销。如有额度需要，请重新注册账户',
    confirmText: '重新注册',
    cancelText: '关闭',
    confirmBtnStyle: 'font-size: 16px',
    cancelBtnStyle: 'font-size: 16px',
    ubtName: '',
  }).then(() => {
    ubtPageButtonNew(that, 'finance_logout_for_register_confirm', {});

    /** 延迟100ms，防止跳转取消埋点上报 */
    setTimeout(() => {
      jumpToNewVersion(
        NewVersionEnum.REGISTER_SMS,
        true,
      );
    }, 100);
  }).catch(() => {
    ubtPageButtonNew(that, 'finance_logout_for_register_cancel', {});
    /** 延迟100ms，防止reload取消埋点上报 */
    setTimeout(() => {
      if (platform.isHelloApp || platform.isAlipayMini || isHelloWechatMini()) {
        if (store.state.base.isHybridAppMode) {
          jumpToWalletTab();
          return;
        }

        closeWebView();
      } else {
        window.location.reload();
      }
    }, 100);
  }).finally(() => {
    hasLogoutConfirmDialog = false;
  });

  ubtPageButtonNew(that, 'finance_logout_for_register', {});
};

/** 关闭账号已注销弹窗 */
export const closeLogoutUserDialog = () => {
  if (hasLogoutConfirmDialog) {
    confirmDialog.close();
    hasLogoutConfirmDialog = false;
  }
};
